import * as $ from "jquery";

$(document).ready(function () {
  var prev = 0;
  const $window = $(window);
  const social = $(".modular-social-bar");

  $window.on("scroll", function () {
    const scrollTop = $window.scrollTop() as number;
    social.toggleClass("hidden", scrollTop > prev);
    prev = scrollTop;
  });
});
